module.exports = __webpack_public_path__ + "img/service_valuation.940a0019.svg";